import React from 'react'

const Care_Sell = () => {
  return (
    <section className="SubServices">
     <h1 className="SubServices-title">Looking to Sell a Care Home</h1>
      <p className="SubServices-pera">Selling a care home is a significant decision that requires expert support and a strategic approach. We help care home owners achieve the best possible outcome by providing professional valuations, market insights, and confidential sales management. From preparing your business for sale to identifying qualified buyers and negotiating offers, our team guides you through every stage of the process, ensuring a smooth, efficient, and successful transaction.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Care_Sell
